import { sizes, TABLET } from '@src/styled/media'
import styled, { css } from 'styled-components'

export const TopHeaderNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  height: 100%;
  justify-content: flex-start;
  flex-grow: 1;
  text-decoration: none;

  > a {
    text-decoration: none;
    position: relative;
  }
`

const navAfterBar = css`
  position: absolute;
  content: '';
  bottom: -4px;
  height: 0px;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.orangeDark};
  transition: bottom 0.2s;
`

export const TopNavLink = styled.a<{ isActive?: boolean }>`
  font-size: ${({ theme }) => theme.font.text.size.md};
  line-height: ${({ theme }) => theme.font.heading.size.md};
  font-weight: bold;
  margin-left: ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.dark};

  @media (max-width: ${sizes[TABLET]}px) {
    display: none;
  }

  :after {
    ${navAfterBar}
  }

  :hover:after {
    height: 5px;
    bottom: -1px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      :after {
        ${navAfterBar}
        height: 5px;
      }
    `}
`



// WEBPACK FOOTER //
// ./src/components/Header/TopNavHeader/styles.tsx